import flatpickr from "flatpickr";

document.addEventListener("DOMContentLoaded", () => {
  const Russian = require("flatpickr/dist/l10n/ru.js").default.ru;

  flatpickr("[data-behavior='flatpickr-reports-date']", {
    altInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    "locale": Russian,
    defaultDate: 'today',
    maxDate: 'today'
  })
})